'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _button = require('@alicd/next/lib/button');

var _button2 = _interopRequireDefault(_button);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _moment = require('@alicd/next/lib/moment');

var _moment2 = _interopRequireDefault(_moment);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuickTool = function (_Component) {
    (0, _inherits3.default)(QuickTool, _Component);

    function QuickTool() {
        (0, _classCallCheck3.default)(this, QuickTool);
        return (0, _possibleConstructorReturn3.default)(this, (QuickTool.__proto__ || (0, _getPrototypeOf2.default)(QuickTool)).apply(this, arguments));
    }

    (0, _createClass3.default)(QuickTool, [{
        key: 'onChange',
        value: function onChange(type) {
            var _props;

            for (var _len = arguments.length, others = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                others[_key - 1] = arguments[_key];
            }

            (_props = this.props).onChange.apply(_props, [type].concat(others));
        }
    }, {
        key: 'isNowValid',
        value: function isNowValid() {
            var disabledDate = this.props.disabledDate;

            var calendarDate = (0, _utils.getCalendarDate)((0, _moment2.default)());
            return (0, _utils.isValidCalendarDate)(calendarDate, disabledDate);
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames,
                _this2 = this;

            var _props2 = this.props,
                locale = _props2.locale,
                module = _props2.module,
                shortcuts = _props2.shortcuts,
                value = _props2.value,
                mode = _props2.mode;

            var prefix = this.context.prefix || this.props.prefix;

            var disabledSelect = function disabledSelect() {
                if (value instanceof Array) {
                    return !value[0] || !value[1];
                } else {
                    return !value;
                }
            };
            var isNowValid = this.isNowValid();

            var selectCls = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, prefix + 'date-picker-quick-tool-select', true), (0, _defineProperty3.default)(_classNames, prefix + 'date-picker-quick-tool-select-disabled', disabledSelect()), _classNames));
            var selectDateAttrs = {
                onClick: disabledSelect() ? null : this.onChange.bind(this, 'select-date')
            };
            var selectTimeAttrs = {
                onClick: disabledSelect() ? null : this.onChange.bind(this, 'select-time')
            };
            return _react2.default.createElement(
                'div',
                { className: prefix + 'date-picker-quick-tool', ref: 'date-picker-quick-tool' },
                module.indexOf('now') >= 0 ? isNowValid ? _react2.default.createElement(
                    'span',
                    { className: prefix + 'date-picker-quick-tool-now', onClick: this.onChange.bind(this, 'now') },
                    locale.now
                ) : _react2.default.createElement(
                    'span',
                    { className: prefix + 'date-picker-quick-tool-now-disabled' },
                    locale.now
                ) : null,
                shortcuts.map(function (item) {
                    return _react2.default.createElement(
                        'span',
                        { key: item, className: prefix + 'date-picker-quick-tool-shortcut', onClick: _this2.onChange.bind(_this2, 'quick-select', item) },
                        item
                    );
                }),
                _react2.default.createElement(
                    _button2.default,
                    { size: 'small', type: 'primary', className: prefix + 'date-picker-quick-tool-ok', onClick: this.onChange.bind(this, 'ok') },
                    locale.ok
                ),
                module.indexOf('select') >= 0 ? mode === 'date' ? _react2.default.createElement(
                    'span',
                    (0, _extends3.default)({ className: selectCls }, selectDateAttrs),
                    locale.selectDate
                ) : _react2.default.createElement(
                    'span',
                    (0, _extends3.default)({ className: selectCls }, selectTimeAttrs),
                    locale.selectTime
                ) : null
            );
        }
    }]);
    return QuickTool;
}(_react.Component);

QuickTool.propTypes = {
    prefix: _propTypes2.default.string,
    value: _propTypes2.default.any,
    module: _propTypes2.default.array,
    shortcuts: _propTypes2.default.array,
    mode: _propTypes2.default.oneOf(['decade', 'year', 'month', 'date']),
    locale: _propTypes2.default.object,
    disabledDate: _propTypes2.default.func,
    onChange: _propTypes2.default.func
};
QuickTool.defaultProps = {
    prefix: 'next-',
    mode: 'month',
    shortcuts: [],
    onChange: function onChange() {}
};
QuickTool.contextTypes = {
    prefix: _propTypes2.default.string
};
exports.default = QuickTool;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-week-picker@0.0.4@@alicd/crui-week-picker/lib/quick-tool.js
// module id = 731
// module chunks = 0